import {useMutation} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {apiClient} from '@common/http/query-client';

export interface VerifyPhoneUpdateEmailOtpPayload {
  code: string;
}

export function useVerifyPhoneUpdateEmailOtp(
  form: UseFormReturn<VerifyPhoneUpdateEmailOtpPayload>,
) {
  return useMutation({
    mutationFn: (payload: VerifyPhoneUpdateEmailOtpPayload) => verify(payload),
    onError: err => onFormQueryError(err, form),
  });
}

function verify(payload: VerifyPhoneUpdateEmailOtpPayload) {
  return apiClient
    .post('phone-update/verify-email-otp', payload)
    .then(response => response.data);
}
